'use strict';

angular.module('Login').controller('ForgotController',function ($scope, AuthenticationService, $location) {
   $scope.showEmailForm = true;
    $scope.showSuccessMessage = false;

    $scope.forgotpassword = function (form) {
        form.email.$setValidity('user', true);
        if (!form.$valid) return;
        $scope.dataLoading = true;
        AuthenticationService.passwordReset({
            email: $scope.email,
            resellerId: $scope.$parent.Company.resellerId
        }, function(response) {
            if (response&&response.status == 200) {
                $scope.showEmailForm = false;
                $scope.showSuccessMessage = true;
                
            }
            $scope.dataLoading = false;
        }, function(error) {
            $scope.error = true;
            $scope.errorMsg = error.data.message;
            form.email.errMsg = error.data.message;
            $scope.dataLoading = false;;
        });
    },

    $scope.redirectToHome = function(){
        $location.path('/auth');
    }
});


//////////////////
// WEBPACK FOOTER
// ./auth/js/controllers/ForgotController.js
// module id = 144
// module chunks = 0